import { Box } from '@primer/react';
import { Caption } from '@primer/gatsby-theme-doctocat';
import * as React from 'react';
export default {
  Box,
  Caption,
  React
};